import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Loader from "../../components/Loader"
import PageContent from "../../components/PageContent"
import Section from "../../components/Section"
import SectionTitle from "../../components/SectionTitle"
import { useNotification } from "../../context/notification"
import { DashboardLayout } from "../../layouts/DashboardLayout"
import { apiRequest } from "../../utils/api"
import getUserIP, { formatIPJSON } from "../../utils/getUserIP"
import useDocumentTitle from "../../utils/useDocumentTitle"
import BulkTable from "./components/BulkTable"
import styles from "./Settings.module.scss"

const RegionManagement = (props) => {
  useDocumentTitle(props.title)
  const { t } = useTranslation()
  const { addNotification } = useNotification();
  const [regionData, setRegionData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    total: 0
  })
  const [selected, setSelected] = useState([]);


  const tableHeaderObj = [
    { name: "title", label: t("regionManagement.title") },
    { name: "region_code", label: t("regionManagement.regionCode") },
    { name: "email_otp_enabled", label: t("regionManagement.emailOtp"), type: "status" },
  ]

  async function fetchData() {
    setIsLoading(true)

    const response = await apiRequest.get(`/api/getAllRegion?page=${pagination.page}&pageSize=${pagination.pageSize}`)

    if (response.status == 200) {
      const data = response.data
      setRegionData(data.data)
      const apiPagination = data.pagination
      setPagination(prev => ({
        ...prev,
        page: apiPagination.page,
        pageSize: apiPagination.pageSize,
        total: apiPagination.total
      }))
    }

    setIsLoading(false)
  }

  useEffect(() => {
    fetchData()
  }, [pagination.page, pagination.pageSize])

  const handleBulkUpdate = async (selected) => {
    try {
      const mappings = []

      for (const s of selected) {
        const row = regionData.find(r => r.id == s.id)

        const mapping = {
          regionCode: row.region_code,
          emailOtpEnabled: s.email_otp_enabled,
        }
        mappings.push(mapping)
      }

      const userIp = await getUserIP();

      const response = await apiRequest.post("/api/region/config", { regions: mappings, userIp: formatIPJSON(userIp) })

      const data = response.data.data

      if (data.status == "success") {
        await fetchData()
        return true
      }
    } catch (error) {
      addNotification(error.response.data.error, "error")
    }
  }

  return (
    <DashboardLayout isDisableCampaignSelection={true}>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <SectionTitle>{t("leftNavigation.regionManagement")}</SectionTitle>
            </div>
            {isLoading ? <Loader /> :
              <BulkTable
                tableHeaderObj={tableHeaderObj}
                data={regionData}
                bulkUpdateFunction={handleBulkUpdate}
                title="Region"
                selected={selected}
                setSelected={setSelected}
                pagination={pagination}
                setPagination={setPagination}
              />
            }

          </Section>
        </PageContent>

      </div>
    </DashboardLayout>
  )
}

export default RegionManagement